import { render, staticRenderFns } from "./NewPasswordInput.vue?vue&type=template&id=574b3f50&scoped=true&"
import script from "./NewPasswordInput.vue?vue&type=script&lang=ts&"
export * from "./NewPasswordInput.vue?vue&type=script&lang=ts&"
import style0 from "./NewPasswordInput.vue?vue&type=style&index=0&id=574b3f50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574b3f50",
  null
  
)

export default component.exports